<template>
  <!--
  <div>
    Forwarded to https://{{this.fwd}}
  </div>
  -->
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      fwd: null
    };
  },
  created(){
    this.fwd=this.$route.query.fwd;
    console.log(this.fwd);
    window. location. href = this.fwd
},  
  mounted: function () {
  },
  methods:
  {    

  },
};
</script>